/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".font2-ico-ssrs-flx[_ngcontent-%COMP%]{font-size:26px}"];
export { styles as styles };
